export enum multiplierAssetConfig {
    //blastAnim = "assets/multiplier/blast_transition.json",
    //    multiplier_blast = "assets/multiplier/scatter_multiplier_effects.json",
    multiplierTextFont = "assets/multiplier/otal_win_value-export.xml",
}